import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { blogPosts } from "@/data/blogData";

const BlogSection = () => (
  <section id="blog" className="bg-gradient-warm py-16 md:py-24">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-12 text-center"
      >
        <span className="mb-3 inline-block rounded-full bg-accent px-4 py-1.5 text-sm font-semibold text-accent-foreground">
          Blog
        </span>
        <h2 className="text-2xl font-extrabold text-foreground sm:text-3xl md:text-4xl">
          Conteúdo que gera <span className="text-gradient-orange">resultado</span>
        </h2>
      </motion.div>

      <div className="grid gap-6 sm:grid-cols-2">
        {blogPosts.slice(0, 4).map((p, i) => (
          <motion.div
            key={p.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
          >
            <Link
              to={`/blog/${p.slug}`}
              className="group flex h-full flex-col rounded-xl border border-border bg-card p-6 shadow-card transition-all hover:shadow-card-hover hover:-translate-y-1"
            >
              <span className="mb-3 inline-block self-start rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground">
                {p.tag}
              </span>
              <h3 className="mb-2 text-lg font-bold text-foreground">{p.title}</h3>
              <p className="mb-4 flex-1 text-sm leading-relaxed text-muted-foreground">{p.excerpt}</p>
              <span className="inline-flex items-center gap-1 text-sm font-semibold text-primary group-hover:underline">
                Ler mais <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-base font-semibold text-primary hover:underline"
        >
          Ver todos os artigos <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default BlogSection;
